import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, FormGroup, Button, FormControl, Row, Col } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { momentHelper } from '../report/helpers'
import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import MessageStore from 'stores/MessageStore'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
const WHOLE_YEAR = momentHelper.getMonth()
class LineMessagePage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      activePage:0,
      pageCount:1,
      itemPerPage:30,
      opt:'',
      optList:[{label:'--- เลือก ---',value:''}],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),  
      data:[],
      isRange:false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      query:''
    }
    this.refTableId = 'LineMessagePage-'+Math.ceil(Math.random()*100)
  }

  componentDidMount(){
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
}

  getSummary() {
    let sum = 0
    let {dataDetail} = this.state
    dataDetail.forEach((item,index)=>{
      sum += (item.amount)*1
    })
    return sum
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  loadData(year='',month='',day='',opt='',query='',start=0,itemPerPage=30) {
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    MessageStore.loadLineMessage(year,month,day,opt,query,start*itemPerPage,itemPerPage,(result)=>{
      this.setState({loading:false,data:result.data,pageCount:Math.ceil(result.data_count/itemPerPage)})
    })
  }

  loadDataRange(start_date='',end_date='',opt='',query='',start=0,itemPerPage=30) {
    MessageStore.loadLineMessageRange(start_date,end_date,opt,query,start*itemPerPage,itemPerPage,(result)=>{
      this.setState({loading:false,data:result.data,pageCount:Math.ceil(result.data_count/itemPerPage)})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=> {
            return(
                <tr key={index}>
                <td className='text-center'>{index+1}</td>
                <td className='text-center'>{item.added_date}</td>
                <td className='text-center'>{item.userid}</td>
                <td className='text-center'>{item.channel_id}</td>
                <td className='text-center'>{item.message_type}</td>
                <td className='text-left'>
                    {
                        item.message.events.map((sitem,sindex)=>{
                            return(
                                <div key={sindex}>
                                    {typeof sitem.message!='undefined'?sitem.message.text:''}
                                </div>    
                            )
                        })
                    }
                </td>
                <td className='text-left'>
                    {typeof item.reply.messages!='undefined'
                    ?
                        item.reply.messages.map((sitem,sindex)=>{
                            return(
                                <div key={sindex}>
                                    {sitem.text!=undefined?sitem.text:''}
                                </div>    
                            )
                        })
                    :''}
                </td>
                </tr>
            )    
        })
      )
    }
  }

  renderTable() {
      return(
        <div className='table-responsive'>
          <table id={this.refTableId} className='table table-bordered-solid table-hover' style={{minWidth:'1280px'}}>
            <thead>
                <tr>
                    <th className='text-center' style={{width:'50px',minWidth:'50px'}}>ลำดับ</th>
                    <th className='text-center' style={{width:'100px',minWidth:'100px'}}>วันที่</th>
                    <th className='text-center' style={{width:'120px',minWidth:'120px'}}>User Id</th>
                    <th className='text-center' style={{width:'120px',minWidth:'120px'}}>Channel Id</th>
                    <th className='text-center' style={{width:'80px',minWidth:'80px'}}>Message Type</th>
                    <th className='text-center' style={{width:'150px',minWidth:'150px'}}>ข้อความ</th>
                    <th className='text-center' style={{width:'150px',minWidth:'150px'}}>ตอบกลับ</th>
                </tr>
            </thead>
            <tbody>
                {this.renderBody()}
            </tbody>
          </table>
        </div>
      )
  }

  onPageSelect(eventKey) {
    this.setState({activePage:eventKey.selected})
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.query,eventKey.selected,this.state.itemPerPage)
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
  }

  onOptChange(val) {
    this.setState({
      opt: val.value, isRange: false
    })
    this.loadData(this.state.year,this.state.month,this.state.day,val.value,this.state.query,this.state.activePage,this.state.itemPerPage)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
  }

  onQueryChange(e) {
    let {query} = this.state
    query = e.target.value
    this.setState({query:query})
  }

  onSearchClick() {
    this.setState({isRange: false})
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
  }

  onSearchKeyPress(e) {
    if (e.charCode==13) {
        this.setState({isRange: false})
        this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
    }
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        {' '}
        <div style={{ width: '150px', display: 'inline-block'}}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.opt}
            options={this.state.optList}
            onChange={this.onOptChange.bind(this)}
          />
        </div>
        {' '}
        <FormGroup style={{verticalAlign:'top'}}>
            <div className="input-group">
                <FormControl
                    value={this.state.query}
                    placeholder="ค้นหา..."
                    onKeyPress={this.onSearchKeyPress.bind(this)}
                    onChange={this.onQueryChange.bind(this)}
                    style={{zIndex:'0'}}
                />
                <span className="input-group-btn" style={{zIndex:'0'}}>
                    <Button 
                        className='btn-flat'
                        onClick={this.onSearchClick.bind(this)}
                    >
                        <FontAwesome name='search' />
                    </Button>
                </span>
            </div>
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={"ก่อนหน้า"}
            nextLabel={"ถัดไป"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageSelect.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </Col>
      </Row>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.query,this.state.activePage,this.state.itemPerPage)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
            Line Messages
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {this.renderPaging()}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

LineMessagePage.defaultProps = {
    
}

export default LineMessagePage;


// WEBPACK FOOTER //
// ./src/view/linemessage/LineMessagePage.js